import CardActionRecommendationContainer from './CardActionRecommendation.container';

export default CardActionRecommendationContainer;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/CardActionRecommendation/index.js